module.exports = {
  prefix: '/api/candidate',
  loginPrefix: '/api/candidate',
};
